document.addEventListener('alpine:init', () => {
  Alpine.data(
    'Theme_Slideshow',
    ({
      autoplay = false,
      autoplayInterval = null,
      mode = 'slideshow',
      gap = null,
      onlyIfNeeded = false,
      deferUntilVisible = false,
    }) => ({
      autoplay,
      autoplayInterval,
      playing: false,
      splide: null,
      rate: 0,
      mode,
      gap,
      onlyIfNeeded,
      deferUntilVisible,
      _started: false,
      _observer: null,
      maxLgBreakpointMQL: window.matchMedia('(max-width: 1023px)'),
      init() {
        if (typeof Splide === 'undefined') {
          console.error(
            'slideshows.js requires a Splide object to be defined in the global scope'
          );

          return;
        }

        this._onBreakpoint = () => {
          if (!this._started && !this.maxLgBreakpointMQL.matches) this.start();
          else if (this._started && this.onlyIfNeeded) this.destroyOrInitIfNeeded();
        };
        this.maxLgBreakpointMQL.addEventListener('change', this._onBreakpoint);
        this._onFocus = () => this.start();
        this.$root.addEventListener('focusin', this._onFocus);

        if (this.deferUntilVisible && this.maxLgBreakpointMQL.matches && !Shopify.designMode && 'IntersectionObserver' in window) {
          this._observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.start();
          }, { rootMargin: '200px 0px' });
          this._observer.observe(this.$root);
        } else this.start();

        if (Shopify.designMode) {
          this._setUpDesignModeHandlers();
        }

        this._onHotReload = async () => {
          if (!Shopify.designMode && this._started) {
            this.splide?.destroy();

            await this.$nextTick();

            if (this.$root.isConnected) this.initSplide();
          }
        };
        document.addEventListener('dev:hotreloadmutation', this._onHotReload);
      },
      start() {
        if (this._started || !this.$root.isConnected) return;
        this._started = true;
        this._observer?.disconnect();
        this._observer = null;
        this.initSplide();
        if (this.onlyIfNeeded) this.destroyOrInitIfNeeded();
        this.$root.dataset.motSlideshowReady = 'true';
        this.$root.querySelector('.splide__pagination')?.dispatchEvent(new CustomEvent('mot:pagination:ready', { bubbles: true }));
      },
      destroy() {
        this._observer?.disconnect();
        this.maxLgBreakpointMQL.removeEventListener('change', this._onBreakpoint);
        this.$root.removeEventListener('focusin', this._onFocus);
        this.$root.removeEventListener('slideshow-go', this._onDesignGo);
        document.removeEventListener('dev:hotreloadmutation', this._onHotReload);
        this.splide?.destroy();
      },
      initSplide() {
        if (splideIsNotDestroyed(this.splide)) return;
        const options = {
          arrows: true,
          pagination: true,
          rewind: true,
          speed: 600,
          start: parseInt(this.$root.dataset.start, 10) - 1 || 0,
          interval: this.autoplayInterval,
          autoplay: this.autoplay,
          drag: !this.autoplay,
        };

        if (this.mode === 'carousel') {
          options.autoWidth = true;
        }

        if (this.gap) {
          options.gap = this.gap;
        }

        this.splide = new Splide(this.$root, options);

        if (options.autoplay) {
          this.splide.on('autoplay:play', () => {
            this.playing = true;
          });

          this.splide.on('autoplay:pause', () => {
            this.playing = false;
          });

          this.splide.on('autoplay:playing', (rate) => {
            this.rate = rate;
          });
        }

        this.splide.mount();
      },
      destroyOrInitIfNeeded() {
        const slideEls = Array.from(
          this.$root.querySelectorAll('.splide__slide')
        );

        const totalSlidesWidth = slideEls.reduce(
          (totalWidth, slideEl) =>
            totalWidth + slideEl.getBoundingClientRect().width,
          0
        );

        const totalGridlinesWidth =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue(
              '--gridline-width'
            )
          ) *
          (slideEls.length - 1);

        const totalContentWidth = totalSlidesWidth + totalGridlinesWidth;

        if (totalContentWidth <= this.$root.getBoundingClientRect().width) {
          if (splideIsNotDestroyed(this.splide)) this.splide.destroy();
        } else {
          if (!splideIsNotDestroyed(this.splide)) this.initSplide();
        }
      },
      _setUpDesignModeHandlers() {
        this._onDesignGo = (e) => {
          if (!e.detail) return;
          this.start();
          this.splide.go(parseInt(e.detail, 10));
        };
        this.$root.addEventListener('slideshow-go', this._onDesignGo);
      },
    })
  );
});
